var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNextIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "k6pohzmcia",
    x1: "-42.375%",
    x2: "148.921%",
    y1: "175.601%",
    y2: "-133.375%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#EA6AC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "40.678%",
    stopColor: "#196BB5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#7DFF7A"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "url(#k6pohzmcia)",
    transform: "translate(-855 -1036)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M38.754 3.011l3.225 3.225h-8.215C32.79 6.236 32 7.026 32 8s.79 1.764 1.764 1.764h8.215l-3.225 3.225c-.69.689-.69 1.806 0 2.494.689.69 1.806.69 2.495 0l6.297-6.299.183-.243.139-.266.069-.203.031-.127.032-.257v-.176l-.032-.257-.042-.167-.132-.32-.116-.185-.132-.167-6.297-6.3c-.69-.688-1.806-.688-2.495 0-.69.69-.69 1.806 0 2.495z",
    transform: "translate(823 1036)"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNextIcon);
export default __webpack_public_path__ + "static/media/nextIcon.15b86b8ca84f65603f21531398dc6c68.svg";
export { ForwardRef as ReactComponent };